import { useKindeAuth } from '@kinde-oss/kinde-auth-react';
import React, { useContext, useEffect, useRef, useState } from 'react';
import style from './AdminApplicants.style';
import { Badge, Button, Card, CardBody, Modal, ModalBody, ModalHeader, UncontrolledTooltip } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faEye,
  faHourglassHalf,
  faMinusCircle,
  faSquareCheck,
  faTimesCircle,
  faCheckCircle,
} from '@fortawesome/free-solid-svg-icons';
import RezRateTable from 'Body/RezRATE/Common/RezRateTable/RezRateTable';
import { fetchDataAgnostic, postDataAgnostic } from 'Services/dataApi';
import { DepartmentContext } from 'DepartmentWrapper';
import { formatBearerToken, checkLoginForError } from 'Common.functions';
import { useAuth0 } from 'auth0/reactAuth0Spa';
import ApplicationForm from 'Body/RezRATE/Body/DirectApplication/ApplicantProfile/ApplyPage/ApplicationForm/ApplicationForm';
import dayjs from 'dayjs';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

import Swal from 'sweetalert2';
import { clone, filter, set } from 'lodash';
import { faSquare } from '@fortawesome/free-regular-svg-icons';
import { toast } from 'react-toastify';
import GenerateApplicationURLCode from 'Body/RezRATE/Body/DirectApplication/GenerateApplicationURLCode/GenerateApplicationURLCode';
import RezRateBanner from 'Body/RezRATE/Common/RezRateBanner/RezRateBanner';

function AdminApplicants() {
  const [applicants, setApplicants] = useState([]);
  const [departmentApplicantData, setDepartmentApplicantData] = useState();
  const [showFormPreview, setShowFormPreview] = useState(false);
  const [columnData, setColumnData] = useState([]);
  const [baseUrl, setBaseUrl] = useState('');

  const [applicantsImportedCount, setApplicantsImportedCount] = useState(0);
  const [applicantsRejectedCount, setApplicantsRejectedCount] = useState(0);
  const [applicantsPendingReviewCount, setApplicantsPendingReviewCount] = useState(0);

  const [sortBy, setSortBy] = useState('LastName');
  const [sortDirection, setSortDirection] = useState('asc');
  const [filterBy, setFilterBy] = useState('');
  const [filteredApplicants, setFilteredApplicants] = useState([]);

  const [isFetchingApplicants, setIsFetchingApplicants] = useState(false);
  const [isFetchingDepartmentApplicantData, setIsFetchingDepartmentApplicantData] = useState(false);
  const [isGeneratingNewCode, setIsGeneratingNewCode] = useState(false);
  const [isSelectedAll, setIsSelectedAll] = useState(false);
  const [isImportingApplicants, setIsImportingApplicants] = useState(false);
  const [isRejectingApplicants, setIsRejectingApplicants] = useState(false);

  const [selectedApplicants, setSelectedApplicants] = useState([]);
  const [applicantToPreview, setApplicantToPreview] = useState();
  const [showApplicantPreview, setShowApplicantPreview] = useState(false);
  const [rawApplicants, setRawApplicants] = useState([]);
  const [lorSummaryByApplication, setLorSummaryByApplication] = useState({});
  const [applicantLoRDetail, setApplicantLoRDetail] = useState({ letters: [], aggregate: null });
  const [isFetchingLoRSummary, setIsFetchingLoRSummary] = useState(false);
  const [isFetchingLoRDetail, setIsFetchingLoRDetail] = useState(false);
  const [isExportingLoRDashboard, setIsExportingLoRDashboard] = useState(false);

  const applicantsRef = useRef();
  const headersRef = useRef([
    {
      label: 'Select',
      dataKey: 'Select',
      width: 50,
      headerFormatter: (headerData) => {
        const { IsSelectedAll } = headerData || {};
        return (
          <FontAwesomeIcon
            icon={IsSelectedAll ? faSquareCheck : faSquare}
            style={{ cursor: 'pointer' }}
            onClick={() => {
              const newValue = !IsSelectedAll;
              const newApplicants = clone(
                applicantsRef.current.map((applicant) => {
                  applicant.isSelected = newValue;
                  return applicant;
                }),
              );
              setApplicants(newApplicants);
              updateSelectAll(newValue);
            }}
          />
        );
      },
      cellFormatter: (cellData, row) => {
        const { isSelected } = row;
        return (
          <div style={{ ...style.simpleRow, justifyContent: 'center' }}>
            <FontAwesomeIcon
              icon={isSelected ? faSquareCheck : faSquare}
              style={{ cursor: 'pointer' }}
              onClick={() => {
                const { pk_ApplicationRecord } = row;

                const existingRow = applicantsRef.current.find(
                  (applicant) => applicant.pk_ApplicationRecord === pk_ApplicationRecord,
                );

                if (existingRow.isSelected) {
                  setApplicants(() => {
                    return applicantsRef.current.map((applicant) => {
                      if (applicant.pk_ApplicationRecord === pk_ApplicationRecord) {
                        return { ...applicant, isSelected: false };
                      }
                      return applicant;
                    });
                  });

                  updateSelectAll(false);
                } else {
                  let newIsSelectedAll = true;
                  setApplicants((prevData) => {
                    return applicantsRef.current.map((applicant, i) => {
                      if (applicant.pk_ApplicationRecord === pk_ApplicationRecord) {
                        return { ...applicant, isSelected: true };
                      }

                      if (!applicant.isSelected) {
                        newIsSelectedAll = false;
                      }

                      if (i === applicantsRef.current.length - 1) {
                        updateSelectAll(newIsSelectedAll);
                      }
                      return applicant;
                    });
                  });
                }
              }}
            />
            {/* {row.isSelected ? 'TRUE' : 'FALSE'} */}
          </div>
        );
      },
    },
    {
      label: 'Status',
      dataKey: 'Status',
      width: 80,
      cellFormatter: (cellData, row) => {
        const { IsRejected, IsImported, IsUnderReview, pk_ApplicationRecord, IsSubmitted } = row;
        const statusId = `status_${pk_ApplicationRecord}`;
        let icon = (
          <>
            <FontAwesomeIcon id={statusId} icon={faMinusCircle} style={{ color: '#808080', cursor: 'pointer' }} />
            <UncontrolledTooltip target={`${statusId}`}>Application has been submitted.</UncontrolledTooltip>
          </>
        );
        if (IsRejected) {
          icon = (
            <>
              <FontAwesomeIcon id={statusId} icon={faTimesCircle} style={{ color: 'red', cursor: 'pointer' }} />
              <UncontrolledTooltip target={`${statusId}`}>Application has been rejected.</UncontrolledTooltip>
            </>
          );
        } else if (IsImported) {
          icon = (
            <>
              <FontAwesomeIcon id={statusId} icon={faCheckCircle} style={{ color: 'green', cursor: 'pointer' }} />
              <UncontrolledTooltip target={`${statusId}`}>Application has been accepted.</UncontrolledTooltip>
            </>
          );
        } else if (!IsRejected && !IsImported && IsUnderReview) {
          icon = (
            <>
              <FontAwesomeIcon id={statusId} icon={faHourglassHalf} style={{ color: '#FFA500', cursor: 'pointer' }} />
              <UncontrolledTooltip target={`${statusId}`}>Application is under review.</UncontrolledTooltip>
            </>
          );
        } else {
          icon = (
            <>
              <FontAwesomeIcon id={statusId} icon={faMinusCircle} style={{ color: '#808080', cursor: 'pointer' }} />
              <UncontrolledTooltip target={`${statusId}`}>Application has been submitted.</UncontrolledTooltip>
            </>
          );
        }

        return <div style={{ ...style.simpleRow, justifyContent: 'center' }}>{icon}</div>;
      },
    },
    {
      label: 'Last Name',
      dataKey: 'LastName',
      width: 200,
    },
    {
      label: 'First Name',
      dataKey: 'FirstName',
      width: 200,
    },
    {
      label: 'Email',
      dataKey: 'Email',
      width: 200,
    },
    {
      label: 'Date Applied',
      dataKey: 'TimestampOfApplicationSubmission',
      width: 150,
      cellFormatter: (TimestampOfApplicationSubmission) => {
        return dayjs(TimestampOfApplicationSubmission).format('MM/DD/YYYY');
      },
      style: { textAlign: 'center' },
    },
    {
      label: 'LoRs',
      dataKey: 'LoRProgress',
      width: 90,
      cellFormatter: (cellData, row) => {
        const { LoRSubmittedCount = 0, LoRRequestedCount = 0 } = row;
        return (
          <div style={{ ...style.simpleRow, justifyContent: 'center' }}>
            {`${LoRSubmittedCount}/${LoRRequestedCount}`}
          </div>
        );
      },
    },
    {
      label: 'LoR Score',
      dataKey: 'LoRCompositeScore',
      width: 110,
      cellFormatter: (cellData, row) => {
        const { LoRCompositeScore } = row;
        return (
          <div style={{ ...style.simpleRow, justifyContent: 'center' }}>
            {LoRCompositeScore !== null && LoRCompositeScore !== undefined ? Number(LoRCompositeScore).toFixed(1) : '--'}
          </div>
        );
      },
    },
    {
      label: 'LoR Activity',
      dataKey: 'LoRLastActivityAt',
      width: 140,
      cellFormatter: (cellData, row) => {
        const { LoRLastActivityAt } = row;
        return (
          <div style={{ ...style.simpleRow, justifyContent: 'center' }}>
            {LoRLastActivityAt ? dayjs(LoRLastActivityAt).format('MM/DD/YYYY') : '--'}
          </div>
        );
      },
    },
    {
      label: 'Actions',
      dataKey: 'action',
      width: 120,
      cellFormatter: (cellData, row) => {
        const { Applicant, pk_ApplicationRecord, IsRejected, IsSubmitted, IsImported } = row;
        const statusId = `action_preview_${pk_ApplicationRecord}`;

        return (
          <div style={{ ...style.simpleRow, justifyContent: 'center' }}>
            <Button
              id={statusId}
              color="primary"
              size="sm"
              onClick={() => {
                setApplicantToPreview({ ...Applicant, pk_ApplicationRecord, IsRejected, IsSubmitted, IsImported });
                setApplicantLoRDetail({ letters: [], aggregate: null });
                fetchApplicantLoRDetail(pk_ApplicationRecord);
                setShowApplicantPreview(true);
              }}
            >
              <FontAwesomeIcon icon={faEye} style={{ cursor: 'pointer' }} />
            </Button>

            <UncontrolledTooltip target={`${statusId}`}>Preview Application</UncontrolledTooltip>

            {/* <Button
              disabled={row.IsRejected || !row.IsSubmitted || row.IsImported}
              id={`${statusId}_import`}
              style={{ marginLeft: 5 }}
              color="success"
              size="sm"
              onClick={() => {
                console.log('row: ', row);
                const { Applicant } = row;
                const { FirstName, LastName } = Applicant || {};

                Swal.fire({
                  title: 'Are you sure?',
                  text: `You are about to IMPORT "${FirstName || ''}${FirstName ? ' ' : ''}${LastName || ''}".`,
                  confirmButtonText: 'Import',
                  showCancelButton: true,
                  cancelButtonText: 'Cancel',
                  icon: 'warning',
                }).then((res) => {
                  console.log('res: ', res);
                  if (res.isConfirmed) {
                    // API CALL
                  }
                });
              }}
            >
              <FontAwesomeIcon icon={faFileImport} style={{ cursor: 'pointer' }} />
            </Button>

            <UncontrolledTooltip target={`${statusId}_import`}>Import this applicant</UncontrolledTooltip>

            <Button
              disabled={row.IsRejected || !row.IsSubmitted || row.IsImported}
              id={`${statusId}_reject`}
              style={{ marginLeft: 5 }}
              color="danger"
              size="sm"
              onClick={() => {
                console.log('row: ', row);
                const { Applicant } = row;
                const { FirstName, LastName } = Applicant || {};
                Swal.fire({
                  title: 'Are you sure?',
                  text: `You are about to REJECT "${FirstName || ''}${FirstName ? ' ' : ''}${LastName || ''}".`,
                  confirmButtonText: 'Import',
                  showCancelButton: true,
                  cancelButtonText: 'Cancel',
                  icon: 'warning',
                }).then((res) => {
                  console.log('res: ', res);
                  if (res.isConfirmed) {
                    // API CALL
                  }
                });
              }}
            >
              <FontAwesomeIcon icon={faThumbsDown} style={{ cursor: 'pointer' }} />
            </Button>

            <UncontrolledTooltip target={`${statusId}_reject`}>Reject this applicant</UncontrolledTooltip> */}
          </div>
        );
      },
    },
  ]);

  const { getTokenSilently, loginWithRedirect } = useAuth0();
  const dContext = useContext(DepartmentContext);

  const history = useHistory();
  const { location } = history;
  const { pathname } = location;

  useEffect(() => {
    fetchApplicants();
    fetchDepartmentApplicantData();
    fetchLoRSummary();
    setColumnData(headersRef.current);
    const { protocol, hostname, port } = window.location;
    const newBaseUrl = `${protocol}//${hostname}${port ? `:${port}` : ''}`;
    setBaseUrl(newBaseUrl);
    // generateFakeApplicants();
  }, []); // Empty dependency array means the effect runs only once, similar to componentDidMount

  useEffect(() => {
    applicantsRef.current = applicants;
  }, [applicants]);

  useEffect(() => {
    if (applicantsRef.current) {
      setSelectedApplicants(applicantsRef.current.filter((applicant) => applicant.isSelected));
    }
  }, [applicantsRef.current]);

  useEffect(() => {
    if (rawApplicants && rawApplicants.length > 0) {
      setApplicants(processApplicants(rawApplicants));
    } else {
      setApplicants([]);
    }
  }, [rawApplicants, lorSummaryByApplication]);

  useEffect(() => {
    if (filterBy === 'All') {
      setFilteredApplicants(applicants);
    } else {
      setFilteredApplicants(filterApplicants(applicants));
    }
  }, [filterBy, applicants]);

  const fetchApplicants = () => {
    setIsFetchingApplicants(true);
    getTokenSilently()
      .then((token) => {
        fetchDataAgnostic(
          'department/application/applicant/list',
          { pk_Department: dContext.department.pk_Department, pk_Season: dContext.season.pk_Season },
          formatBearerToken(token),
        )
          .then((res) => {
            setIsFetchingApplicants(false);
            const nextApplicants = res.data.filter((applicant) => applicant.IsSubmitted);
            setRawApplicants(nextApplicants);
            setApplicants(processApplicants(nextApplicants));
          })
          .catch((err) => {
            setIsFetchingApplicants(false);
            console.log('fetchApplicants err: ', err);
          });
      })
      .catch((err) => {
        setIsFetchingApplicants(false);
        console.log('getToken err: ', err);
        checkLoginForError({ err, loginWithRedirect });
      });
  };

  const fetchDepartmentApplicantData = () => {
    setIsFetchingDepartmentApplicantData(true);
    getTokenSilently()
      .then((token) => {
        fetchDataAgnostic(
          'department/application/list',
          { pk_Department: dContext.department.pk_Department },
          formatBearerToken(token),
        )
          .then((res) => {
            setDepartmentApplicantData(res.data);
          })
          .catch((err) => {
            console.log('fetchDepartmentApplicantData err: ', err);
          })
          .finally(() => {
            setIsFetchingDepartmentApplicantData(false);
          });
      })
      .catch((err) => {
        setIsFetchingDepartmentApplicantData(false);
        console.log('getToken err: ', err);
        checkLoginForError({ err, loginWithRedirect });
      });
  };

  const fetchLoRSummary = () => {
    setIsFetchingLoRSummary(true);
    getTokenSilently()
      .then((token) => {
        fetchDataAgnostic(
          'department/application/letters/list',
          { pk_Department: dContext.department.pk_Department, pk_Season: dContext.season.pk_Season },
          formatBearerToken(token),
        )
          .then((res) => {
            const byApplication = {};
            const rows = res?.data?.lettersByApplication || [];
            rows.forEach((row) => {
              byApplication[row.pk_ApplicationRecord] = row;
            });
            setLorSummaryByApplication(byApplication);
          })
          .catch((err) => {
            console.log('fetchLoRSummary err: ', err);
          })
          .finally(() => {
            setIsFetchingLoRSummary(false);
          });
      })
      .catch((err) => {
        setIsFetchingLoRSummary(false);
        console.log('getToken err: ', err);
        checkLoginForError({ err, loginWithRedirect });
      });
  };

  const fetchApplicantLoRDetail = (pk_ApplicationRecord) => {
    if (!pk_ApplicationRecord) {
      return;
    }

    setIsFetchingLoRDetail(true);
    getTokenSilently()
      .then((token) => {
        fetchDataAgnostic(
          'department/application/letters/detail',
          {
            pk_Department: dContext.department.pk_Department,
            pk_Season: dContext.season.pk_Season,
            pk_ApplicationRecord,
          },
          formatBearerToken(token),
        )
          .then((res) => {
            setApplicantLoRDetail({
              letters: res?.data?.letters || [],
              aggregate: res?.data?.aggregate || null,
            });
          })
          .catch((err) => {
            console.log('fetchApplicantLoRDetail err: ', err);
            setApplicantLoRDetail({ letters: [], aggregate: null });
          })
          .finally(() => {
            setIsFetchingLoRDetail(false);
          });
      })
      .catch((err) => {
        setIsFetchingLoRDetail(false);
        console.log('getToken err: ', err);
        checkLoginForError({ err, loginWithRedirect });
      });
  };

  const openLoRDocument = (pk_LoRRequest) => {
    if (!pk_LoRRequest) {
      return;
    }

    getTokenSilently()
      .then((token) => {
        fetchDataAgnostic(
          'department/application/letters/document',
          {
            pk_Department: dContext.department.pk_Department,
            pk_LoRRequest,
            EventType: 'viewed',
          },
          formatBearerToken(token),
        )
          .then((res) => {
            const url = res?.data?.DocumentUrl;
            if (url) {
              window.open(url, '_blank', 'noopener,noreferrer');
            } else {
              toast.error('No document available');
            }
          })
          .catch((err) => {
            toast.error('Failed to open LoR document');
          });
      })
      .catch((err) => {
        checkLoginForError({ err, loginWithRedirect });
      });
  };

  const exportLoRDashboard = () => {
    setIsExportingLoRDashboard(true);
    getTokenSilently()
      .then((token) => {
        fetchDataAgnostic(
          'department/application/letters/dashboard-export',
          {
            pk_Department: dContext.department.pk_Department,
            pk_Season: dContext.season.pk_Season,
            FilterBy: filterBy || 'All',
          },
          formatBearerToken(token),
        )
          .then((res) => {
            const csvText = typeof res?.data === 'string' ? res.data : '';
            if (!csvText) {
              toast.error('No LoR dashboard data available for export');
              return;
            }

            const disposition = res?.headers?.['content-disposition'] || '';
            const filenameMatch = disposition.match(/filename="?([^";]+)"?/i);
            const fileName = filenameMatch ? filenameMatch[1] : 'lor_dashboard.csv';

            const blob = new Blob([csvText], { type: 'text/csv;charset=utf-8;' });
            const blobUrl = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = blobUrl;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(blobUrl);
          })
          .catch((err) => {
            console.log('exportLoRDashboard err: ', err);
            toast.error('Failed to export LoR dashboard CSV');
          })
          .finally(() => {
            setIsExportingLoRDashboard(false);
          });
      })
      .catch((err) => {
        setIsExportingLoRDashboard(false);
        checkLoginForError({ err, loginWithRedirect });
      });
  };

  const filterApplicants = (applicantsToFilter) => {
    const newApplicants = applicantsToFilter.filter((applicant) => {
      const { IsRejected, IsImported, IsUnderReview, IsSubmitted } = applicant;

      if (filterBy === 'All' || !filterBy) {
        return true;
      } else if (filterBy === 'Rejected') {
        return IsRejected && !IsImported;
      } else if (filterBy === 'Imported') {
        return !IsRejected && IsImported;
      } else {
        return (IsUnderReview || IsSubmitted) && !IsImported && !IsRejected;
      }
    });

    return newApplicants;
  };

  const sortApplicants = (applicantsToSort) => {
    const newApplicants = applicantsToSort.sort((a, b) => {
      if (sortDirection === 'asc') {
        if (a[sortBy] < b[sortBy]) {
          return -1;
        }
        if (a[sortBy] > b[sortBy]) {
          return 1;
        }
        return 0;
      } else {
        if (a[sortBy] > b[sortBy]) {
          return -1;
        }
        if (a[sortBy] < b[sortBy]) {
          return 1;
        }
        return 0;
      }
    });

    return newApplicants;
  };

  const updateSelectAll = (newValue) => {
    // Make function for setting selectAll
    const newColumnData = clone(headersRef.current);
    const newColumn0 = clone(newColumnData[0]);

    newColumn0.IsSelectedAll = newValue;

    newColumnData[0] = newColumn0;
    setIsSelectedAll(newValue);

    setColumnData(newColumnData);
  };

  const generateNewCode = () => {
    setIsGeneratingNewCode(true);
    getTokenSilently()
      .then((token) => {
        postDataAgnostic(
          'department/application/code',
          { pk_Department: dContext.department.pk_Department },
          null,
          formatBearerToken(token),
        )
          .then((result) => {
            setIsGeneratingNewCode(false);
            toast.success('New code generated successfully');
            fetchDepartmentApplicantData();
          })
          .catch((err) => {
            console.log('err: ', err);
            setIsGeneratingNewCode(false);
            toast.error('Failed to generate new code');
          });
      })
      .catch((err) => {
        setIsGeneratingNewCode(false);
        console.log('getToken err: ', err);
        checkLoginForError({ err, loginWithRedirect });
      });
  };

  const renderFormPreview = () => {
    return (
      <Modal
        isOpen={showFormPreview}
        toggle={() => setShowFormPreview(!showFormPreview)}
        size="lg"
        style={{ minWidth: '90vw' }}
      >
        <ModalHeader toggle={() => setShowFormPreview(!showFormPreview)}>Application Form Preview</ModalHeader>

        <ModalBody>
          <ApplicationForm isAdmin={true} isReadOnly={true} />
        </ModalBody>
      </Modal>
    );
  };

  const generateFakeApplicants = () => {
    const fakeApplicants = [];
    for (let i = 0; i < 10; i++) {
      const applicant = {
        Applicant: {
          LastName: `Last Name ${i}`,
          FirstName: `First Name ${i}`,
          Email: `email${i}@example.com`,
          dateApplied: new Date().toISOString(),
        },
      };
      fakeApplicants.push(applicant);
    }
    setApplicants(fakeApplicants);
  };

  const processApplicants = (applicantsToProcess) => {
    let newApplicantsRejectedCount = 0;
    let newApplicantsImportedCount = 0;
    let newApplicantsPendingReviewCount = 0;

    const newApplicants = applicantsToProcess
      .filter((appplicant) => {
        return appplicant.IsSubmitted;
      })
      .map((applicant) => {
        const { IsRejected, IsInvited, IsImported, IsUnderReview, IsSubmitted } = applicant;
        const loRSummary = lorSummaryByApplication[applicant.pk_ApplicationRecord] || {};
        if (IsImported) {
          newApplicantsImportedCount++;
        } else if (IsRejected) {
          newApplicantsRejectedCount++;
        } else if (IsUnderReview || IsSubmitted) {
          newApplicantsPendingReviewCount++;
        }

        return {
          ...applicant.Applicant,
          ...applicant,
          LoRRequestedCount: loRSummary.RequestedCount || 0,
          LoRSubmittedCount: loRSummary.SubmittedCount || 0,
          LoRPendingCount: loRSummary.PendingCount || 0,
          LoRCompositeScore:
            loRSummary.CompositeNormalized !== null && loRSummary.CompositeNormalized !== undefined
              ? Number(loRSummary.CompositeNormalized)
              : null,
          LoRLastActivityAt: loRSummary.LastActivityAt || null,
        };
      })
      .sort((a, b) => {
        const aText = `${a.LastName || ''}, ${a.FirstName || ''}`;
        const bText = `${b.LastName || ''}, ${b.FirstName || ''}`;

        if (aText < bText) {
          return -1;
        }
        if (aText > bText) {
          return 1;
        }
        return 0;
      });
    setApplicantsImportedCount(newApplicantsImportedCount);
    setApplicantsRejectedCount(newApplicantsRejectedCount);
    setApplicantsPendingReviewCount(newApplicantsPendingReviewCount);

    return newApplicants;
  };

  const importApplicants = (forcedApplicants) => {
    if (!forcedApplicants || forcedApplicants.length <= 0) {
      Swal.fire('Error', 'No valid applicants to accept.', 'error');
      return;
    }

    setIsImportingApplicants(true);
    getTokenSilently()
      .then((token) => {
        postDataAgnostic(
          'department/application/import',
          { pk_Department: dContext.department.pk_Department, pk_Season: dContext.season.pk_Season },
          {
            pk_ApplicationRecords: forcedApplicants,
          },
          formatBearerToken(token),
        )
          .then((res) => {
            // toast.success('Applicants imported successfully');
            Swal.fire({
              title: 'Success',
              text: `${forcedApplicants.length} applicant${
                forcedApplicants.length > 1 ? 's' : ''
              } imported successfully`,
              icon: 'success',
              confirmButtonText: 'OK',
              timer: 1500,
            });
            fetchApplicants();
            fetchLoRSummary();
            setSelectedApplicants([]);
            setShowApplicantPreview(false);
          })
          .catch((err) => {
            Swal.fire({
              title: 'Error',
              text: 'Failed to import applicants',
              icon: 'error',
              confirmButtonText: 'OK',
              timer: 1500,
            });
            // toast.error('Failed to import applicants!');
          })
          .finally(() => {
            setIsImportingApplicants(false);
          });
      })
      .catch((err) => {
        console.log('err: ', err);
        setIsImportingApplicants(false);
        checkLoginForError({ err, loginWithRedirect });
      });
  };

  const rejectApplicants = (forcedApplicants) => {
    if (!forcedApplicants || forcedApplicants.length <= 0) {
      return;
    }
    setIsRejectingApplicants(true);

    getTokenSilently()
      .then((token) => {
        postDataAgnostic(
          'department/application/reject',
          { pk_Department: dContext.department.pk_Department, pk_Season: dContext.season.pk_Season },
          {
            pk_ApplicationRecords: forcedApplicants ? forcedApplicants : [],
          },
          formatBearerToken(token),
        )
          .then((res) => {
            // toast.success(`Applicant${selectedApplicants.length > 1 ? 's' : ''}rejected successfully`);
            Swal.fire({
              title: 'Success',
              text: `Applicant${selectedApplicants.length > 1 ? 's' : ''} rejected successfully`,
              icon: 'success',
              confirmButtonText: 'OK',
              timer: 1500,
            });

            fetchApplicants();
            fetchLoRSummary();
            setSelectedApplicants([]);
            setShowApplicantPreview(false);
          })
          .catch((err) => {
            Swal.fire({
              title: 'Error',
              text: `Failed to reject applicant${selectedApplicants.length > 1 ? 's' : ''}!`,
              icon: 'error',
              confirmButtonText: 'OK',
              timer: 1500,
            });
            // toast.error(`Failed to reject applicant${selectedApplicants.length > 1 ? 's' : ''}!`);
          })
          .finally(() => {
            setIsRejectingApplicants(false);
          });
      })
      .catch((err) => {
        console.log('err: ', err);
        toast.error(`Failed to reject applicant${selectedApplicants.length > 1 ? 's' : ''}!`);
        setIsRejectingApplicants(false);
        checkLoginForError({ err, loginWithRedirect });
      });
  };

  const renderFormPreviewForApplicant = () => {
    const { LastName, FirstName, pk_ApplicationRecord, IsRejected, IsSubmitted, IsImported } = applicantToPreview || {};
    const displayName = `${LastName || ''}${LastName && FirstName ? ', ' : ''}${FirstName || ''}`;

    return (
      <Modal
        isOpen={showApplicantPreview}
        toggle={() => setShowApplicantPreview(!showApplicantPreview)}
        size="lg"
        style={{ minWidth: '90vw' }}
      >
        <ModalHeader toggle={() => setShowApplicantPreview(!showApplicantPreview)}>
          Application Form Preview for {displayName}
        </ModalHeader>

        <ModalBody style={{ paddingTop: 5 }}>
          {IsRejected || IsImported ? (
            <>
              <RezRateBanner
                message={
                  IsImported ? (
                    <span style={{ fontWeight: 'bold' }}>Application Imported</span>
                  ) : (
                    <span style={{ fontWeight: 'bold' }}>Application Rejected</span>
                  )
                }
                backgroundColor={IsImported ? '#38d662' : '#e81300'}
                // textColor={'white'}
              />
              <div style={{ borderBottom: '2px gray solid', paddingBottom: 5, marginBottom: 5 }} />
            </>
          ) : (
            <div
              style={{
                ...style.simpleRow,
                width: '100%',
                justifyContent: 'flex-end',
                borderBottom: '2px gray solid',
                paddingBottom: 5,
                marginBottom: 5,
              }}
            >
              <Button
                size="sm"
                color="primary"
                style={{ width: 200, marginRight: 10 }}
                disabled={isImportingApplicants || isRejectingApplicants}
                onClick={() => {
                  Swal.fire({
                    title: 'Are you sure?',
                    text: `This will import ${displayName}. Are you sure you want to proceed?`,
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No',
                  }).then((result) => {
                    if (result.isConfirmed) {
                      importApplicants([pk_ApplicationRecord]);
                    }
                  });
                }}
              >
                Accept Application
              </Button>
              <Button
                size="sm"
                color="danger"
                style={{ width: 100 }}
                disabled={isImportingApplicants || isRejectingApplicants}
                onClick={() => {
                  Swal.fire({
                    title: 'Are you sure?',
                    text: `This will reject ${displayName}. Are you sure you want to proceed?`,
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No',
                  }).then((result) => {
                    if (result.isConfirmed) {
                      rejectApplicants([pk_ApplicationRecord]);
                    }
                  });
                }}
              >
                Reject
              </Button>
            </div>
          )}

          <Card style={{ width: '100%', marginBottom: 8 }}>
            <CardBody>
              <div style={{ ...style.simpleRow, justifyContent: 'space-between', alignItems: 'flex-start' }}>
                <div style={{ ...style.simpleColumn, alignItems: 'flex-start' }}>
                  <div style={{ fontWeight: 'bold', marginBottom: 4 }}>Letters of Recommendation</div>
                  {isFetchingLoRDetail ? (
                    <div>Loading LoR details...</div>
                  ) : (
                    <>
                      <div style={{ marginBottom: 6 }}>
                        <Badge color="dark" style={{ marginRight: 6 }}>
                          {`Letters: ${applicantLoRDetail.letters.length}`}
                        </Badge>
                        <Badge color="info" style={{ marginRight: 6 }}>
                          {`Submitted: ${
                            applicantLoRDetail.letters.filter((item) => item.SubmittedAt || item.Locked).length
                          }`}
                        </Badge>
                        <Badge color="secondary">
                          {`Composite: ${
                            applicantLoRDetail.aggregate && applicantLoRDetail.aggregate.CompositeNormalized !== null
                              ? Number(applicantLoRDetail.aggregate.CompositeNormalized).toFixed(1)
                              : '--'
                          }`}
                        </Badge>
                      </div>

                      {applicantLoRDetail.letters.length === 0 ? (
                        <div style={{ fontSize: 13 }}>No LoRs assigned for this application.</div>
                      ) : (
                        <div style={{ width: '100%', maxHeight: 180, overflowY: 'auto' }}>
                          {applicantLoRDetail.letters.map((letter) => {
                            const latestStatus =
                              (letter.StatusEvents && letter.StatusEvents[0] && letter.StatusEvents[0].Status) ||
                              letter.LatestStatus ||
                              '--';
                            return (
                              <div
                                key={letter.fk_LoRRequest}
                                style={{
                                  ...style.simpleRow,
                                  justifyContent: 'space-between',
                                  borderBottom: '1px solid #efefef',
                                  paddingBottom: 6,
                                  marginBottom: 6,
                                }}
                              >
                                <div style={{ ...style.simpleColumn, alignItems: 'flex-start' }}>
                                  <div style={{ fontWeight: 'bold' }}>{letter.AuthorName || letter.AuthorEmail}</div>
                                  <div style={{ fontSize: 12 }}>{letter.AuthorEmail}</div>
                                  <div style={{ fontSize: 12 }}>
                                    {`${letter.LetterType || 'narrative'} | ${latestStatus} | ${
                                      letter.SubmittedAt ? dayjs(letter.SubmittedAt).format('MM/DD/YYYY') : 'not submitted'
                                    }`}
                                  </div>
                                </div>
                                <div>
                                  <Button
                                    size="sm"
                                    color="secondary"
                                    disabled={!letter.SubmittedAt && !letter.Locked}
                                    onClick={() => openLoRDocument(letter.fk_LoRRequest)}
                                  >
                                    View
                                  </Button>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      )}
                    </>
                  )}
                </div>
              </div>
            </CardBody>
          </Card>

          <ApplicationForm isAdmin={true} isReadOnly={true} applicantDetails={applicantToPreview} />
        </ModalBody>
      </Modal>
    );
  };

  const { Department = {} } = departmentApplicantData || {};

  return (
    <div style={{ ...style.simpleRow, justifyContent: 'center' }}>
      <div style={{ ...style.simpleColumn }}>
        <div style={{ ...style.simpleRow, justifyContent: 'center' }}>
          <div style={{ ...style.simpleColumn, width: '90vw' }}>
            <div style={{ ...style.simpleRow, width: '100%' }}>
              <GenerateApplicationURLCode />
            </div>
          </div>
        </div>
        <div style={{ ...style.simpleRow, fontSize: 14, marginTop: 5, justifyContent: 'center' }}>
          <div style={{ ...style.simpleColumn, width: '90vw' }}>
            <Card style={{ width: '100%' }}>
              <CardBody>
                <div style={{ ...style.simpleColumn, width: 'auto', flexWrap: 'wrap' }}>
                  <div style={{ ...style.simpleRow, fontWeight: 'bold', justifyContent: 'center', flexWrap: 'wrap' }}>
                    <div style={{ ...style.simpleColumn, width: 80, alignItems: 'center', justifyContent: 'center' }}>
                      Applicants
                    </div>{' '}
                    {isFetchingLoRSummary ? (
                      <div style={{ ...style.simpleColumn, width: 140, marginLeft: 5, fontSize: 12, color: '#666' }}>
                        Updating LoR data...
                      </div>
                    ) : null}
                    <div style={{ ...style.simpleColumn, width: 100, marginLeft: 5 }}>
                      {' '}
                      <Button
                        size="sm"
                        outline
                        onClick={() => {
                          setFilterBy('All');
                        }}
                      >
                        {' '}
                        Total: <Badge color="dark">{applicants.length}</Badge>{' '}
                      </Button>
                    </div>
                    <div style={{ ...style.simpleColumn, width: 'auto', marginLeft: 5 }}>
                      {' '}
                      <Button
                        size="sm"
                        outline
                        onClick={() => {
                          setFilterBy('Imported');
                        }}
                      >
                        <FontAwesomeIcon
                          icon={faCheckCircle}
                          style={{ color: 'green', cursor: 'pointer', marginRight: 5 }}
                        />
                        Application Accepted: <Badge color="dark">{applicantsImportedCount}</Badge>{' '}
                      </Button>
                    </div>
                    <div style={{ ...style.simpleColumn, width: 140, marginLeft: 5 }}>
                      {' '}
                      <Button
                        size="sm"
                        outline
                        onClick={() => {
                          setFilterBy('Rejected');
                        }}
                      >
                        <FontAwesomeIcon
                          icon={faTimesCircle}
                          style={{ color: 'red', cursor: 'pointer', marginRight: 5 }}
                        />
                        Rejected: <Badge color="dark">{applicantsRejectedCount}</Badge>{' '}
                      </Button>
                    </div>
                    <div style={{ ...style.simpleColumn, width: 190, marginLeft: 5 }}>
                      <Button
                        size="sm"
                        outline
                        onClick={() => {
                          setFilterBy('Pending Review');
                        }}
                      >
                        <FontAwesomeIcon icon={faHourglassHalf} style={{ color: '#FFA500', marginRight: 5 }} />
                        Pending Review: <Badge color="dark">{applicantsPendingReviewCount}</Badge>{' '}
                      </Button>
                    </div>
                    <div style={{ ...style.simpleColumn, width: 'auto', marginLeft: 5 }}>
                      <Button
                        size="sm"
                        color="secondary"
                        outline
                        disabled={isExportingLoRDashboard}
                        onClick={exportLoRDashboard}
                      >
                        {isExportingLoRDashboard ? 'Exporting LoR CSV...' : 'Export LoR Dashboard CSV'}
                      </Button>
                    </div>
                  </div>
                  <div
                    id="tableContainer"
                    style={{
                      ...style.simpleRow,
                      marginTop: 10,
                      justifyContent: 'center',
                      // overflow: 'auto',
                      width: '100%',
                      // overflowX: 'auto',
                    }}
                  >
                    <div
                      style={{ ...style.simpleColumn, width: 'auto', justifyContent: 'flex-start', overflow: 'auto' }}
                    >
                      <RezRateTable
                        data={filteredApplicants || []}
                        tableBodyHeight={`calc(100vh - 510px)`}
                        columns={columnData || []}
                        noDataMessage={isFetchingApplicants ? 'Loading. . .' : '----'}
                        onRowClick={(row) => {
                          // console.log('row: ', row);
                        }}
                        rowStyle={(rowData) => {
                          const { isSelected } = rowData;
                          if (isSelected) {
                            return {
                              backgroundColor: '#ADD8E6',
                            };
                          } else {
                            return {};
                          }
                        }}
                      />
                    </div>
                  </div>
                  <div
                    style={{
                      ...style.simpleRow,
                      justifyContent: 'center',
                      marginTop: 10,
                      overflow: 'auto',
                      width: '100%',
                    }}
                  >
                    <Button
                      size="sm"
                      color="primary"
                      style={{ width: 200 }}
                      disabled={selectedApplicants.length <= 0 || isImportingApplicants}
                      onClick={() => {
                        Swal.fire({
                          title: 'Are you sure?',
                          text: `This will import the ${selectedApplicants.length}${' '}selected applicant${
                            selectedApplicants.length > 1 ? 's' : ''
                          }. Are you sure you want to proceed?`,
                          icon: 'warning',
                          showCancelButton: true,
                          confirmButtonText: 'Yes',
                          cancelButtonText: 'No',
                        }).then((result) => {
                          if (result.isConfirmed) {
                            importApplicants(
                              selectedApplicants.filter((applicant) => {
                                return !applicant.IsImported && !applicant.IsRejected && applicant.IsSubmitted;
                              }),
                            );
                          }
                        });
                      }}
                    >
                      Accept Application
                    </Button>
                  </div>
                </div>
              </CardBody>
            </Card>
          </div>
        </div>

        {renderFormPreview()}
        {renderFormPreviewForApplicant()}
      </div>
    </div>
  );
}

export default AdminApplicants;
